/* eslint-disable import/order */
import { addModal, addStylesToSchema } from '@/exceed';
import i18n from 'i18next';

import getTagContentSchema from '../schemas/getTagContentSchema';

import styles from '../styles/tagContentModal.module.scss';

export default () => addModal({
  actions: [
    {
      action: 'save',
      color: 'brand',
      element: 'button',
      getIsDisabled: ({ hasFormError }) => hasFormError,
      text: i18n.t('save'),
    },
    {
      action: 'cancel',
      element: 'button',
      text: i18n.t('cancel'),
      variant: 'ghost',
    },
  ],
  className: styles.element,
  hasCloseButton: true,
  isFullScreen: true,
  schema: addStylesToSchema(getTagContentSchema(), styles),
  title: i18n.t('content-tagging'),
});
